export * from './pagination';
export * from './id';
export * from './currency';

export interface CatalogoRef {
  id: number;
  key: string | null;
  value: string | null;
}

export interface ClienteRef {
  id: number;
  nombre: string | null;
  identificacion: string | null;
  /** Código del cliente (campo legacy `ip`, reutilizado como código AID). */
  ip: string | null;
}

export interface UsuarioRef {
  id: string;
  email: string;
  username: string;
}

/**
 * Date-only API contract: a calendar date serialized as a bare `YYYY-MM-DD`
 * string (the value of a PostgreSQL DATE column). Response types use this
 * alias for DATE-backed fields; fields typed `Date` are REAL instants
 * (timestamptz, e.g. fechaCreacion/fechaPago) and must never be parsed with
 * date-only helpers. Consumers parse it with the frontend `parseDateOnly`
 * helper (apps/aid-frontend/src/lib/date.ts) so a legacy ISO-midnight value
 * (`2026-09-01T00:00:00.000Z`) can never render as the previous day in a
 * UTC-negative timezone. The one UI exception is `fechaAlta` (timestamptz on
 * the wire, date-only in the edit form): its frontend parser is
 * `parseFechaAlta` and the backend write contract is `businessMidnightInstant`
 * (apps/aid-backend/src/core/utils/fechas.ts) — both keyed to migration 0012
 * (Guatemala midnight = 06:00 UTC).
 */
export type DateOnlyString = string;

/** Provenance of an event location: device GPS or the client's saved point. */
export const UBICACION_ORIGEN = {
  GPS: 'GPS',
  CLIENTE: 'CLIENTE',
} as const;

export type UbicacionOrigen = (typeof UBICACION_ORIGEN)[keyof typeof UBICACION_ORIGEN];
